import React from 'react';

const HomePage: React.FC = () => {
  const companyInfo = {
    name: '深圳市青牛网域信息有限公司',
    unifiedSocialCreditCode: '91440300MADHKMJP0N',
    legalRepresentative: '陈实',
    companyType: '有限责任公司 (自然人独资)',
    establishmentDate: '2024年05月06日',
    address: '深圳市罗湖区莲塘街道莲花社区港莲路22号城市东座2005',
    businessScope: [
      '商事主体的经营范围由章程确定。经营范围中属于法律、法规规定应当经批准的项目,取得许可审批文件后方可开展相关经营活动。',
      '商事主体经营范围和许可审批项目等有关企业信用事项及年报信息和其他信用信息,请登录左下角国家企业信用信息公示系统或扫描右上方的二维码查询。',
      '各商事主体每年须于成立周年之日起两个月内,向商事登记机关提交上一自然年度的年度报告。企业应当按照《企业信息公示暂行条例》第十条的规定向社会公示企业信息。'
    ]
  };

  return (
    <div className="bg-gray-50 min-h-screen font-sans text-gray-800">
      {/* Header */}
      <header className="bg-white shadow-md">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="text-2xl font-bold text-blue-600">{companyInfo.name}</div>
            <div className="hidden md:flex space-x-6">
              <a href="#about" className="text-gray-600 hover:text-blue-500 transition duration-300">关于我们</a>
              <a href="#services" className="text-gray-600 hover:text-blue-500 transition duration-300">经营范围</a>
              <a href="#contact" className="text-gray-600 hover:text-blue-500 transition duration-300">联系我们</a>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="bg-blue-600 text-white text-center py-20">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">欢迎来到 {companyInfo.name}</h1>
          <p className="text-lg md:text-xl text-blue-100">您值得信赖的合作伙伴</p>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">关于我们</h2>
          <div className="max-w-4xl mx-auto bg-gray-100 p-8 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="font-semibold text-lg mb-2">公司名称:</h4>
                <p>{companyInfo.name}</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">法定代表人:</h4>
                <p>{companyInfo.legalRepresentative}</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">成立日期:</h4>
                <p>{companyInfo.establishmentDate}</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">公司类型:</h4>
                <p>{companyInfo.companyType}</p>
              </div>
              <div className="md:col-span-2">
                <h4 className="font-semibold text-lg mb-2">统一社会信用代码:</h4>
                <p>{companyInfo.unifiedSocialCreditCode}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Scope Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">经营范围</h2>
          <div className="max-w-4xl mx-auto space-y-4">
            {companyInfo.businessScope.map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-blue-500">
                <p className="text-gray-700">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-8">联系我们</h2>
          <div className="max-w-2xl mx-auto">
            <div className="bg-gray-100 p-8 rounded-lg shadow-lg inline-block">
                <h4 className="font-semibold text-lg mb-2">公司地址</h4>
                <p className="text-gray-700">{companyInfo.address}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-6">
        <div className="container mx-auto px-6 text-center">
          <p className="mb-2">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-300">
              粤ICP备2024302302号
            </a>
          </p>
          <p>&copy; {new Date().getFullYear()} {companyInfo.name}. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;